import { Injectable } from "@angular/core";
import { BaseGridResponse } from "planning-portal-library/src/lib/data/shared/base-grid.response";
import { BaseRequest } from "planning-portal-library/src/lib/data/shared/base.request";
import { Observable } from "rxjs";

import { UseCase } from "../../base/use-case";
import { GetLocationsRequest, Location } from "../../domain";
import { LocationsRepository } from "../../repositories";

@Injectable({ providedIn: 'root' })
export class GetLocationsUsecase implements UseCase<BaseRequest<GetLocationsRequest>, BaseGridResponse<Location>> {

  constructor(private locationRepository: LocationsRepository) {
  }

  execute(params: BaseRequest<GetLocationsRequest>): Observable<BaseGridResponse<Location>> {
    return this.locationRepository.getLocations(params);
  }

}
